import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@c2fo/liquidity/icons';

interface BackLinkProps {
  to: string;
  label: string;
}

export const BackLink: React.FC<BackLinkProps> = ({ to, label }) => {
  return (
    <div className="mt-4 mb-6">
      <Link
        to={to}
        className="inline-flex items-center gap-1 ml-2 text-base text-primary-600 hover:text-primary-700 hover:underline"
      >
        <ArrowLeftIcon className="h-4 w-4" />
        {label}
      </Link>
    </div>
  );
};
